<template>
  <div class="flex items-center">
    <button class="column-btn column-1" :class="{ active: columns === '1' }" data-test="column-1" @click="handleColumnChange('1')" />
    <button class="column-btn column-2" :class="{ active: columns === '2' }" data-test="column-2" @click="handleColumnChange('2')" />
    <button class="column-btn column-3" :class="{ active: columns === '3' }" data-test="column-3" @click="handleColumnChange('3')" />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount,  useBreakpoints } from '#imports'
const { isMobile } = useBreakpoints()
const emit = defineEmits(['update:columns'])

const columns = defineModel('columns', {
  type: String,
  default: '1',
})

const handleColumnChange = (column: string) => {
  emit('update:columns', column)
}

const handleResize = () => {
  const { isMobile } = useBreakpoints() // fresh instance
  if (
    (!isMobile.value && columns.value === '1') ||
    (isMobile.value && columns.value === '3')
  ) {
    handleColumnChange('2')
  }
}

onMounted(() => {
  if (!isMobile.value) {
    handleColumnChange('2')
  }

  window.addEventListener('resize', handleResize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize)
})
</script>
<style scoped>
.column-btn {
  @apply h-6 mt-1 bg-no-repeat bg-contain bg-center;
}

.column-btn.column-1 {
  @apply w-7 md:hidden;
  background-image: url('/img/icons/grid-1-column-inactive.svg');
}

.column-btn.column-2 {
  @apply w-8 mx-3;
  background-image: url('/img/icons/grid-2-column-inactive.svg');
}

.column-btn.column-3 {
  @apply w-11 hidden md:block;
  background-image: url('/img/icons/grid-3-column-inactive.svg');
}

.column-btn.column-1:hover {
  background-image: url('/img/icons/grid-1-column-hover.svg');
}

.column-btn.column-2:hover {
  background-image: url('/img/icons/grid-2-column-hover.svg');
}

.column-btn.column-3:hover {
  background-image: url('/img/icons/grid-3-column-hover.svg');
}

.column-btn.column-1.active,
.column-btn.column-1.active:hover {
  background-image: url('/img/icons/grid-1-column-active.svg');
}

.column-btn.column-2.active,
.column-btn.column-2.active:hover {
  background-image: url('/img/icons/grid-2-column-active.svg');
}

.column-btn.column-3.active,
.column-btn.column-3.active:hover {
  background-image: url('/img/icons/grid-3-column-active.svg');
}

</style>
